import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M2.707 10.59q-1.113 0-1.676-.563Q.47 9.454.47 8.293V3.055q0-1.16.562-1.723Q1.594.77 2.707.77h7.582q1.113 0 1.676.562t.562 1.723v5.238q0 1.16-.562 1.734-.563.563-1.676.563zm14.004 0q-1.113 0-1.676-.563-.562-.573-.562-1.734V3.055q0-1.16.562-1.723.563-.562 1.676-.562h7.582q1.113 0 1.676.562t.562 1.723v5.238q0 1.16-.562 1.734-.563.563-1.676.563zM2.707 22.344q-1.112 0-1.676-.563Q.47 21.22.47 20.06v-5.25q0-1.149.562-1.711.563-.575 1.676-.575h7.582q1.113 0 1.676.575.562.563.562 1.71v5.25q0 1.16-.562 1.723t-1.676.563zm14.004 0q-1.113 0-1.676-.563t-.562-1.722v-5.25q0-1.149.562-1.711.563-.575 1.676-.575h7.582q1.113 0 1.676.575.562.563.562 1.71v5.25q0 1.16-.562 1.723t-1.676.563z"
    }, null, -1)
  ]))]))
}
export default { render: render }